import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { cx } from '../cx';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'ghost' | 'quiet';
  size?: 'md' | 'sm';
  block?: boolean;
}

export function Button({ variant = 'ghost', size = 'md', block, className, type = 'button', ...rest }: ButtonProps) {
  return (
    <button
      type={type}
      className={cx('rr-btn', `rr-btn--${variant}`, size === 'sm' && 'rr-btn--sm', block && 'rr-btn--block', className)}
      {...rest}
    />
  );
}

export function Arrow({ direction = 'right' }: { direction?: 'right' | 'left' | 'up-right' }) {
  const paths = {
    right: 'M2 7h10M8 3l4 4-4 4',
    left: 'M12 7H2M6 3L2 7l4 4',
    'up-right': 'M3 11L11 3M5 3h6v6',
  };
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path d={paths[direction]} stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/** "investigar →" */
export function ActionLink({
  children,
  bare,
  className,
  as: Component = 'button',
  ...rest
}: { children: ReactNode; bare?: boolean; as?: 'button' | 'a' | 'span' } & Record<string, unknown>) {
  const Tag = Component as 'button';
  return (
    <Tag className={cx('rr-action', bare && 'rr-action--bare', className as string)} type={Component === 'button' ? 'button' : undefined} {...rest}>
      <span>{children}</span>
      <span className="rr-action__arrow">
        <Arrow />
      </span>
    </Tag>
  );
}
